import {getFollowupCount} from '@/api/module/followup';
import {defineStore} from 'pinia';
import {ref, watch} from 'vue';
import {useSettings} from './settings';

const SECONDS_MS = 15 * 1000;
const FETCH_INTERVAL = SECONDS_MS;

export const useFollowupCountStore = defineStore('followup-count-store', () => {
  const followupCount = ref(0);
  let interval = null as NodeJS.Timeout | null;
  async function fetchFollowupCount() {
    try {
      if (interval) clearTimeout(interval);
      interval = null;
      followupCount.value = await getFollowupCount();
    } catch (err) {
      console.error(err);
    } finally {
      interval = setTimeout(fetchFollowupCount, FETCH_INTERVAL);
    }
  }

  const authStore = useSettings();
  watch(() => authStore.userToken, fetchFollowupCount, {immediate: true});

  return {
    followupCount,
    fetchFollowupCount,
  };
});
